// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#signatureDialog .modal-body div[data-v-2bf64d60],.signature[data-v-2bf64d60]{border:1px solid;border-radius:4px}", ""]);
// Exports
module.exports = exports;
